import { createContext, useContext } from 'react';

/**
 * Authentication Context
 * Provides authentication state to components via Context API
 */
interface AuthContextValue {
  isAuthenticated: boolean;
}

export const AuthContext = createContext<AuthContextValue>({
  isAuthenticated: false,
});

/**
 * Hook to access authentication context
 * Must be used within AuthContext.Provider
 */
export const useAuthContext = () => useContext(AuthContext);
